import _ from 'lodash';
import { DEFAULT_LOCALE } from '@fiverr-private/fiverr_context/lib/constants';

export const extractUGC = ({
    general,
    locale = DEFAULT_LOCALE,
    overview,
    description,
    sellerCard,
    faq,
    gallery = {},
    packages = {},
    studio = {}
}) => {
    const { gig } = overview;
    const { title } = gig;
    const { isStudio } = general;

    return {
        gigTitle: `${getTitlePrefix({ isStudio, locale })} ${title}`,
        description: _.pick(description, 'content'),
        sellerCard: _.pick(sellerCard, ['description']),
        studio: extractStudioContent(studio),
        faq,
        listings: {},
        galleryReviews: extractGalleryReviews(gallery),
        packages: extractPackagesContent(packages)
    };
};

export const getTitlePrefix = ({ isStudio, locale }) => {

    const key = isStudio ? 'our_studio_will' : 'i_will';

    return i18n.t(`gig_page_perseus.general.${key}`, { $scope: locale });
};

const extractGalleryReviews = ({ slides }) => {
    const reviews = {};
    slides.forEach(({ slide: { review } = {} }) => {
        if (review) {
            reviews[review.id] = review.text;
        }
    });

    return reviews;
};

const extractPackagesContent = ({ packageList = [] }) => {
    const packages = {};

    packageList.forEach(({ title, description, customExtras = [], id }) => {
        packages[id] = {
            title,
            description,
            customExtras: customExtras.map(({ label, buyerTooltip }) => ({ label, buyerTooltip }))
        };
    });

    return packages;
};

const extractStudioContent = ({ info }) => _.pick(info, ['tagline']);
